function uuid () {
  var seed = Date.now()
  if (window.performance && typeof window.performance.now === 'function') {
    seed += performance.now()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (seed + Math.random() * 16) % 16 | 0
    seed = Math.floor(seed / 16)

    return (c === 'x' ? r : r & (0x3 | 0x8)).toString(16)
  })
}

function trackGetVisitor () {
  var visitorId = (window.localStorage && localStorage.vid) || uuid()
  if (window.localStorage) {
    try {
      localStorage.vid = visitorId
    } catch (e) {}
  }

  return visitorId
}

function trackGetSession () {
  var val = window.localStorage && localStorage.vvd
  var valIndex = val ? val.split('*') : []
  var timeStart = '' + Math.floor((new Date()).valueOf() / 10800000)
  var sessionId
  if (valIndex.length === 2 && valIndex[0] === timeStart) {
    sessionId = valIndex[1]
  } else {
    sessionId = uuid()
    if (window.localStorage) {
      try {
        localStorage.vvd = timeStart + '*' + sessionId
      } catch (e) {}
    }
  }

  return sessionId
}

function trackHit () {
  if (window.config.widget) {
    return
  }

  $.post('/_t/hit', {
    page: window.config.pageId || 0,
    site: window.config.siteId || 0,
    visitorId: trackGetVisitor(),
    sessionId: trackGetSession(),
    url: location.href
  })
}

function trackSearch (term) {
  $.post('/_t/search', {
    term: term,
    page: window.config.pageId || 0,
    site: window.config.siteId || 0,
    visitorId: trackGetVisitor(),
    sessionId: trackGetSession(),
    widget: window.config.widget || 0,
    url: location.href
  })
}

var searchTrackTimeout = null
window.trackSearchThrottled = function (term) {
  if (searchTrackTimeout) {
    clearTimeout(searchTrackTimeout)
  }
  searchTrackTimeout = setTimeout(function () {
    searchTrackTimeout = null
    trackSearch(term)
  }, 3000)
}

$(document).on('pjax:end', trackHit)
$(document).ready(trackHit)
